import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { useSettings } from "../../context/SettingsContext";
import { PageHeader } from "../../components/PageHeader";
import { ImageUploader } from "../../components/ImageUploader";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Button } from "../../components/ui/button";

export default function AppSettings() {
  const { settings, setSettings } = useSettings();
  const [form, setForm] = useState(settings);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setForm(settings);
  }, [settings]);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.put("/admin/settings", form);
      setSettings(data);
      toast.success("Pengaturan aplikasi disimpan");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={save} data-testid="app-settings-form">
      <PageHeader title="Pengaturan Aplikasi" subtitle="Logo, favicon dan judul aplikasi untuk seluruh platform.">
        <Button type="submit" disabled={busy} className="rounded-xl" data-testid="app-settings-save-button">{busy ? "Menyimpan..." : "Simpan"}</Button>
      </PageHeader>
      <div className="grid lg:grid-cols-3 gap-6">
        <section className="lg:col-span-2 rounded-2xl border border-slate-200 bg-white p-5 sm:p-6 space-y-4 fade-up">
          <div className="space-y-1.5">
            <Label>Judul aplikasi</Label>
            <Input required maxLength={60} value={form.app_title} onChange={(e) => setForm((f) => ({ ...f, app_title: e.target.value }))} data-testid="app-title-input" />
            <p className="text-xs text-slate-500">Tampil di logo, tab browser dan nama aplikasi saat di-install (PWA).</p>
          </div>
          <div className="grid grid-cols-2 gap-6">
            <div className="space-y-1.5">
              <Label>Logo</Label>
              <div className="max-w-[160px]"><ImageUploader multiple={false} value={form.logo} onChange={(v) => setForm((f) => ({ ...f, logo: v }))} testId="app-logo-upload" /></div>
              <p className="text-xs text-slate-500">Persegi, PNG transparan. Juga dipakai sebagai ikon aplikasi.</p>
            </div>
            <div className="space-y-1.5">
              <Label>Favicon</Label>
              <div className="max-w-[100px]"><ImageUploader multiple={false} value={form.favicon} onChange={(v) => setForm((f) => ({ ...f, favicon: v }))} testId="app-favicon-upload" /></div>
              <p className="text-xs text-slate-500">Ikon kecil di tab browser.</p>
            </div>
          </div>
        </section>
        <section className="rounded-2xl border border-slate-200 bg-white p-5 sm:p-6 fade-up">
          <h3 className="font-bold mb-4">Pratinjau ikon aplikasi</h3>
          <div className="flex items-end gap-4">
            <img src={`${process.env.REACT_APP_BACKEND_URL}/api/pwa/icon-192.png?v=${encodeURIComponent(settings.logo || "d")}`} alt="" className="h-20 w-20 rounded-2xl border border-slate-200" />
            <div className="text-sm"><p className="font-semibold">{settings.app_title}</p><p className="text-xs text-slate-500">Ikon di layar HP</p></div>
          </div>
        </section>
      </div>
    </form>
  );
}
